import { registerApplication, start } from "single-spa";
import * as Sentry from "@sentry/browser";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";

import microfrontendLayout from "./microfrontend-layout.html";
// eslint-disable-next-line
if (top === self) {
  // Initialize Google Tag Manager at the root level
  if (!window.dataLayer || window.dataLayer.length < 1) {
    // Create dataLayer array
    window.dataLayer = window.dataLayer || [];
    
    // Insert the GTM script
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${process.env.VUE_APP_GTAGMANAGER_ID}');
    `;
    document.head.appendChild(gtmScript);
    
    // Setup gtag function
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    
    // Configure gtag
    window.gtag('config', process.env.VUE_APP_GTAGMANAGER_ID, {
      linker: {
        accept_incoming: true,
      },
    });
  }

  const routes = constructRoutes(microfrontendLayout);
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);
  layoutEngine.activate();
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(require("./service-worker.js"))
      .catch(function () {
        // handle errors
      });
  }
  start();
} else {
  // eslint-disable-next-line
  top.location.replace(document.location)
  alert(
    "For security reasons, framing is not allowed; click OK to remove the frames."
  );
}
const userLoginData = window.localStorage.getItem("login_data")
  ? JSON.parse(window.localStorage.getItem("login_data"))
  : null;
//console.log(process.env.VUE_APP_SENTRY_DSN);
Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,

  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  release: "mailercloud-campaign@1.0.0",
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration({
      enableInp: true,
    })
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [process.env.TRACE_PROPAGATION_TARGET_1],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
Sentry.setUser({
  id: userLoginData?.cid,
});
Sentry.setTag("plan_type", userLoginData?.plan);

window.Sentry = Sentry;
